import {
  BreakpointAction,
  ChoiceFunction,
  EligibleAppleWatchBreakpointOption,
  QuizDataInput,
} from '@naturalcycles/shared'
import { Page } from '@src/app/shared/typings/enum/pages.js'
import { allQuizSections } from '../quiz.js'

const commonTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  flow[allQuizSections.routine] = [
    Page.naturalMethod,
    Page.yourMeasuringDevice,
    Page.whichWearable,
    Page.eligibleAppleWatch,
    Page.equallyEffectiveInfo,
    Page.nightSleep,
    Page.troubleGettingBackToSleep,
    Page.sleepWearable,
    Page.wearYourWatchToBed,
    Page.sleepConsistency,
    Page.spendingDaysInfo,
    Page.healthGoals,
    Page.feelingStressed,
    Page.biggestStressor,
    Page.favoriteWayToUnwind,
    Page.deviceTrait,
    Page.resultOverview,
  ]
  return flow
}

export const eligibleAppleWatch: BreakpointAction<
  EligibleAppleWatchBreakpointOption,
  Page,
  QuizDataInput
> = {
  [EligibleAppleWatchBreakpointOption.yes]: commonTransformFunction,
  [EligibleAppleWatchBreakpointOption.no]: flow => {
    flow[allQuizSections.routine] = [
      Page.naturalMethod,
      Page.yourMeasuringDevice,
      Page.whichWearable,
      Page.eligibleAppleWatch,
      Page.purchaseNewWatch,
      Page.equallyEffectiveInfo,
      Page.nightSleep,
      Page.troubleGettingBackToSleep,
      Page.sleepWearable,
      Page.wearYourWatchToBed,
      Page.sleepConsistency,
      Page.spendingDaysInfo,
      Page.healthGoals,
      Page.feelingStressed,
      Page.biggestStressor,
      Page.favoriteWayToUnwind,
      Page.deviceTrait,
      Page.resultOverview,
    ]
    return flow
  },
}
